var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { TextField } from '@mui/material';
import { inject, observer } from 'mobx-react';
var CustomFieldText = /** @class */ (function (_super) {
    __extends(CustomFieldText, _super);
    function CustomFieldText(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isFocused: false
        };
        return _this;
    }
    Object.defineProperty(CustomFieldText.prototype, "render", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var error = this.props.field.value.length === 0 && this.props.field.isMandatory;
            var label = this.props.label;
            if (this.state.isFocused && this.props.maxLength && this.props.field.value)
                label += " (" + this.props.field.value.length + " / " + this.props.maxLength + ")";
            return (_jsx(TextField, { variant: "outlined", fullWidth: true, onFocus: function (e) { return _this.onFocus(e); }, onBlur: function (e) { return _this.onBlur(e); }, InputLabelProps: { shrink: true }, inputProps: { maxLength: this.props.maxLength }, onChange: function (e) { return _this.onValueChanged(e); }, value: this.props.field.value, label: label, required: this.props.field.isMandatory && !this.props.field.value, error: error }, void 0));
        }
    });
    Object.defineProperty(CustomFieldText.prototype, "renderEditor", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return (_jsx("div", { children: "Editor" }, void 0));
        }
    });
    Object.defineProperty(CustomFieldText.prototype, "onValueChanged", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e) {
            var _a;
            var value = e.target.value;
            (_a = this.props.fieldsStore) === null || _a === void 0 ? void 0 : _a.updateFieldValue(this.props.field, value);
        }
    });
    Object.defineProperty(CustomFieldText.prototype, "onFocus", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e) {
            this.setState(__assign(__assign({}, this.state), { isFocused: true }));
        }
    });
    Object.defineProperty(CustomFieldText.prototype, "onBlur", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e) {
            this.setState(__assign(__assign({}, this.state), { isFocused: false }));
        }
    });
    CustomFieldText = __decorate([
        inject('fieldsStore'),
        observer
    ], CustomFieldText);
    return CustomFieldText;
}(React.Component));
export default CustomFieldText;
